var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "evaluate-box" },
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "我的反馈",
          "right-text": "问题反馈",
          fixed: "",
        },
        on: { "click-left": _vm.resultClick, "click-right": _vm.onClickRight },
      }),
      _c(
        "div",
        { staticClass: "div-conter" },
        [
          _c(
            "van-pull-refresh",
            {
              on: { refresh: _vm.onRefresh },
              model: {
                value: _vm.refreshing,
                callback: function ($$v) {
                  _vm.refreshing = $$v
                },
                expression: "refreshing",
              },
            },
            [
              _c(
                "van-list",
                {
                  attrs: {
                    finished: _vm.finished,
                    "finished-text": "没有更多了",
                    "immediate-check": false,
                  },
                  on: { load: _vm.onLoad },
                  model: {
                    value: _vm.loading,
                    callback: function ($$v) {
                      _vm.loading = $$v
                    },
                    expression: "loading",
                  },
                },
                _vm._l(_vm.list, function (item, index) {
                  return _c("div", { key: index, staticClass: "borderCss" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          padding: "10px 16px",
                          "align-items": "center",
                          "background-color": "white",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.detail(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "13px",
                                  "font-weight": "600",
                                },
                              },
                              [_vm._v(_vm._s(item.pfTypeStr))]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.pfStatus == 1,
                                    expression: "item.pfStatus==1 ",
                                  },
                                ],
                                staticClass: "icon-circleThree",
                                staticStyle: { "margin-left": "15px" },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "icon-circle-class" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.pfStatus == 1 ? "已解决" : "未解决"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "13px",
                              color: "#bfbfbf",
                            },
                          },
                          [_vm._v(_vm._s(item.pfTimeStr))]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "13px",
                          color: "#bfbfbf",
                          padding: "5px 16px 20px 16px",
                          "background-color": "white",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          "white-space": "nowrap",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.detail(item)
                          },
                        },
                      },
                      [_vm._v(_vm._s(item.pfDesc))]
                    ),
                  ])
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }